import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FilterListIcon from '@material-ui/icons/FilterList';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import Chip from '@material-ui/core/Chip';
import { useTranslation } from 'react-i18next';
import ApiService from '../../services/ApiService';
import {
  setNotifications,
  setSelectedBusinessUnits,
  allBusinessUnitsState,
  selectedBusinessUnitsState,
} from '../HomePage/HomeSlice';
import useStyles from './styles';

export default function FilterNotificationPopUp(props) {
  const { open } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const selectedBusinessUnits = useSelector(selectedBusinessUnitsState);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = React.useState(
    selectedBusinessUnits ? selectedBusinessUnits.businessUnits : [],
  );
  const allBusinessUnits = useSelector(allBusinessUnitsState);
  const dispatch = useDispatch();

  function handleValidate() {
    if (selectedBusinessUnit.length > 0) {
      const requestBody = { businessUnits: selectedBusinessUnit };
      ApiService.filterNotificationsByBusinessUnits(requestBody).then(
        (result) => {
          dispatch(setNotifications(result.data));
          dispatch(setSelectedBusinessUnits(requestBody));

          props.setOpenFilterState(false);
        },
      );
    } else {
      ApiService.getLatestNotifications().then((result) => {
        dispatch(setNotifications(result.data));

        dispatch(setSelectedBusinessUnits(null));

        props.setOpenFilterState(false);
      });
    }
  }
  function handleClose() {
    setSelectedBusinessUnit(
      selectedBusinessUnits ? selectedBusinessUnits.businessUnits : [],
    );
    props.setOpenFilterState(false);
  }

  const handleChange = (event) => {
    setSelectedBusinessUnit(event.target.value);
  };

  return (
    <Dialog open={open} onClose={handleClose} className={classes.dialogStyle}>
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <FilterListIcon
            className={classes.largeFilterIcon}
            fontSize="large"
          />
        </Grid>
        <Grid item xs={10}>
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography className={classes.dialogTitle}>
                  {t('Notification parameters')}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.dialog}>
            <DialogContentText className={classes.dialogText}>
              {t('filter notifications text')}
            </DialogContentText>
            <Typography className={classes.subTitle}>
              {t('For which business do you want to be notified')}{' '}
            </Typography>

            {allBusinessUnits.length > 0 && (
              <FormControl className={classes.formControl}>
                <Select
                  className={classes.dropdownStyle}
                  multiple
                  value={selectedBusinessUnit}
                  onChange={handleChange}
                  input={<Input className={classes.dialogText} />}
                  renderValue={(selected) => (
                    <div className={classes.chips}>
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={value}
                          className={classes.chip}
                        />
                      ))}
                    </div>
                  )}
                  MenuProps={{
                    classes: {
                      paper: classes.dropdownStyle,
                    },
                    PopoverClasses: { root: classes.selectMenuPopover },
                  }}
                  IconComponent={UnfoldMoreIcon}
                  inputProps={{
                    classes: {
                      icon:
                        selectedBusinessUnit.length > 0 ? classes.icon : null,
                    },
                  }}
                >
                  {allBusinessUnits.map((businessUnit) => (
                    <MenuItem key={businessUnit} value={businessUnit}>
                      <Checkbox
                        classes={{
                          root: classes.root,
                          checked: classes.checked,
                        }}
                        checked={
                          selectedBusinessUnit.indexOf(businessUnit) > -1
                        }
                      />
                      <ListItemText
                        classes={{ primary: classes.dialogText }}
                        primary={businessUnit}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions style={{ margin: 32 }}>
            <Button
              className={classes.cancelButton}
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              {t('Cancel')}
            </Button>
            <Button
              className={classes.validateButton}
              variant="contained"
              autoFocus
              onClick={handleValidate}
              color="secondary"
            >
              {t('Validate')}
            </Button>
          </DialogActions>
        </Grid>
        <Grid item xs={1}>
          <IconButton className={classes.closeIcon} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Dialog>
  );
}
